// Wave UX-2.2 #9 (2026-05-23) — 외부 바이어 첫 로그인 온보딩.
// 4-step modal. localStorage flag 'autodex_buyer_onboarded' 로 1회만 표시.
// Dashboard 진입 시 자동 mount (Dashboard 첫 진입점 — 다른 화면은 직접 navigate).
// Skip / Next / Prev / Done CTA.

import React, { useState, useEffect } from 'react';
import { useT } from '../../i18n/I18nProvider';

var STORAGE_KEY = 'autodex_buyer_onboarded';

var STEPS = [
  { titleKey: 'onboardStep1Title', bodyKey: 'onboardStep1Body', emoji: '👋' },
  { titleKey: 'onboardStep2Title', bodyKey: 'onboardStep2Body', emoji: '🔨' },
  { titleKey: 'onboardStep3Title', bodyKey: 'onboardStep3Body', emoji: '📋' },
  { titleKey: 'onboardStep4Title', bodyKey: 'onboardStep4Body', emoji: '⚡' },
];

export function shouldShowOnboarding() {
  try { return localStorage.getItem(STORAGE_KEY) !== '1'; } catch (e) { return false; }
}

function markOnboarded() {
  try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
}

function OnboardingModal(props) {
  var t = useT();
  var [open, setOpen] = useState(props.forceOpen === true || shouldShowOnboarding());
  var [idx, setIdx] = useState(0);

  useEffect(function() {
    // 처음 mount 시 상태 결정 — props.forceOpen true 면 무조건 표시 (디버그/테스트용)
    if (props.forceOpen === true) setOpen(true);
  }, [props.forceOpen]);

  if (!open) return null;

  var total = STEPS.length;
  var step = STEPS[idx];
  var isFirst = idx === 0;
  var isLast = idx === total - 1;

  function close() {
    markOnboarded();
    setOpen(false);
    if (props.onClose) props.onClose();
  }

  return (
    <div onClick={close}
      style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(15,23,42,0.55)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1000,
      }}>
      <div onClick={function(e){ e.stopPropagation(); }}
        style={{
          background: 'white', borderRadius: 18,
          width: 'calc(100% - 40px)', maxWidth: 440,
          padding: 32,
          boxShadow: '0 24px 60px rgba(0,0,0,0.25)',
          textAlign: 'center',
        }}>

        {/* progress dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 6, marginBottom: 28 }}>
          {STEPS.map(function(_, i){
            return <span key={i} style={{
              width: i === idx ? 22 : 6, height: 6,
              borderRadius: 999,
              background: i === idx ? '#1B3A5C' : '#e2e8f0',
              transition: 'width 0.2s',
            }} />;
          })}
        </div>

        {/* emoji + title + body */}
        <div style={{ fontSize: 56, marginBottom: 18, opacity: 0.9 }}>{step.emoji}</div>
        <h2 style={{ fontSize: 20, fontWeight: 800, color: '#0f172a', marginBottom: 12 }}>
          {t(step.titleKey)}
        </h2>
        <p style={{ fontSize: 14, color: '#64748b', lineHeight: 1.6, marginBottom: 28, minHeight: 80 }}>
          {t(step.bodyKey)}
        </p>

        {/* CTAs */}
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 12 }}>
          <button type="button" onClick={close}
            style={{
              background: 'none', border: 'none', cursor: 'pointer',
              fontSize: 13, fontWeight: 600, color: '#94a3b8', padding: '8px 12px',
            }}>
            {t('onboardSkip')}
          </button>

          <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 600 }}>
            {t('onboardStepProgress', { n: idx + 1, total: total })}
          </span>

          <div style={{ display: 'flex', gap: 8 }}>
            {!isFirst && (
              <button type="button" onClick={function(){ setIdx(idx - 1); }}
                style={{
                  background: 'white', border: '1.5px solid #e2e8f0', borderRadius: 10,
                  padding: '10px 14px', cursor: 'pointer',
                  fontSize: 13, fontWeight: 700, color: '#475569',                }}>
                {t('onboardPrev')}
              </button>
            )}
            <button type="button" onClick={isLast ? close : function(){ setIdx(idx + 1); }}
              style={{
                background: 'linear-gradient(135deg, #1B3A5C 0%, #3b82f6 100%)',
                color: 'white', border: 'none', borderRadius: 10,
                padding: '10px 18px', cursor: 'pointer',
                fontSize: 13, fontWeight: 800,                boxShadow: '0 4px 12px rgba(27,58,92,0.18)',
              }}>
              {isLast ? t('onboardDone') : t('onboardNext')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OnboardingModal;
